import TruncateSegments from './truncate-segments';

export * from './truncate-segments';

export default TruncateSegments;
